/**
 * Legacy Synthesis route — redirects to ADOS-Informed Coding.
 *
 * The old combined "Synthesis" page was split into two appointment phases
 * (ADOS-informed coding → Criterion Mapping). Bookmarks and deep links to
 * `/observation/synthesis` still land somewhere useful via this redirect.
 */

import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { getAutismOBSStepRoutes } from '../../../../utils/autismObsRouting';

export default function ObsSynthesisRedirect() {
  const { patientId } = useParams();
  return <Navigate to={getAutismOBSStepRoutes(patientId).adosCoding} replace />;
}
